export * from './modal-changeDictator.component'